import { Route, Routes, useParams } from "react-router";

import { SentryErrorBoundary } from "@nens/sentry";

import { ProjectPage } from "../pages/project-page";

export function ProjectRoutes() {
  const { slug } = useParams();

  if (!slug) return null;

  return (
    <Routes>
      <Route
        path="/"
        element={
          <SentryErrorBoundary appName="rana" theme="rana">
            <ProjectPage slug={slug} />
          </SentryErrorBoundary>
        }
      />
    </Routes>
  );
}
